import { render, staticRenderFns } from "./InterpreterVideo.vue?vue&type=template&id=7fa3a296&scoped=true&"
import script from "./InterpreterVideo.vue?vue&type=script&lang=js&"
export * from "./InterpreterVideo.vue?vue&type=script&lang=js&"
import style0 from "./InterpreterVideo.vue?vue&type=style&index=0&id=7fa3a296&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa3a296",
  null
  
)

export default component.exports